import { INS_BASE_REST_URL } from './URL';
import axios from 'axios';
import store from '../sessionStorage';
import Constants from './Constants';
import { myLog } from './Utility';
import { deactivateUserScreen, networkProblem } from '../voim/action/NetworkAction';
import stores from '../stores';
import { domainConfigurations } from './common/DomainConfiguration';
import { getTranslation } from './common/LanguageContext';

export const axiosCommon = axios.create({
    baseURL: store.get('INS_BASE_REST_URL'),
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        'X-Auth-Method': 'cookie',
    },
});

export default class Client {
    static axiosCommonInstance(config) {
        return axios.create({ baseURL: store.get('INS_BASE_REST_URL') })(config);
    }

    static httpHeader(isAccessToken, isVersion) {
        let d = new Date();
        let headers = {};
        headers = {
            'Content-Type': 'application/json',
            offset: d.getTimezoneOffset(),
        };
        if (isAccessToken) {
            headers = {
                'Content-Type': 'application/json',
                offset: d.getTimezoneOffset(),
                'X-Auth-Method': 'cookie',
            };
            if (isVersion) {
                let version = 'X-API-Version';
                headers[version] = 'chat-v2';
            }
        }
        return headers;
    }

    static cleverHeader(cleverToken) {
        let d = new Date();
        let headers = {};
        headers = {
            'Content-Type': 'application/json',
            offset: d.getTimezoneOffset(),
            'user-id': store.get('bloomIfAI_id'),
        };
        if (cleverToken) {
            headers = {
                'Content-Type': 'application/json',
                offset: d.getTimezoneOffset(),
                'X-Auth-Method': 'cookie',
                // If cleverToken is present, still prefer cookie auth, but fallback if needed
                // Authorization: `Bearer ${cleverToken}`,
            };
        }
        return headers;
    }

    static httpHeaderFormData(isAccessToken) {
        let d = new Date();
        let headers = {};
        headers = {
            'Content-Type': 'multipart/form-data',
            offset: d.getTimezoneOffset(),
        };
        if (isAccessToken) {
            headers = {
                'Content-Type': 'multipart/form-data',
                offset: d.getTimezoneOffset(),
                'X-Auth-Method': 'cookie',
            };
        }

        return headers;
    }

    static get(url, params, isAccessToken) {
        return new Promise(function (success, failed) {
            const config = {
                method: 'GET',
                url,
                params,
                headers:
                    params && params.cleverToken
                        ? Client.cleverHeader(params.cleverToken)
                        : Client.httpHeader(isAccessToken, false),
                withCredentials: true,
            };
            myLog('GET ::::::: INPUT', config);
            axios
                .create({
                    baseURL: INS_BASE_REST_URL,
                })(config)
                .then((response) => {
                    try {
                        if (
                            response.status === Constants.HTTP_CODE.AUTHENTICATION_FAILURE ||
                            response.status === Constants.HTTP_CODE.REQUIRED_MISSING
                        ) {
                            throw new Error({
                                name: response.status,
                                message: Constants.VALIDATION_MSG.AUTH_FAILED,
                            });
                        }
                        if (response.status === Constants.HTTP_CODE.SUCCESS) {
                            try {
                                return response.data;
                            } catch (e) {
                                throw new Error({
                                    name: response.status,
                                    message: Constants.VALIDATION_MSG.REQ_FAILED,
                                });
                            }
                        }
                    } catch (e) {
                        throw new Error({
                            name: response.status,
                            message: Constants.VALIDATION_MSG.REQ_FAILED,
                        });
                    }
                })
                .then((response) => {
                    myLog('GET ::::::: response', response);
                    success(response);
                })
                .catch((err) => {
                    myLog('GET ::::::: err', err);
                    if (
                        err.response &&
                        err.response.status === Constants.HTTP_CODE.REQUIRED_MISSING
                    ) {
                        showSessionExpiredModal();
                    } else {
                        failed(CatchErrorHandler(err.message));
                    }
                });
        });
    }

    // A third party has no session cookie, so the endpoints they reach are
    // authorised with the service key from the environment instead. Everything
    // else matches Client.get.
    static getWithAuthKey(url, params) {
        return new Promise(function (success, failed) {
            const authKey = process.env.REACT_APP_VISIT_STATUS_AUTH_KEY;
            const config = {
                method: 'GET',
                url,
                params,
                headers: {
                    ...(authKey ? { 'X-Auth-Key': authKey } : {}),
                },
                withCredentials: false,
            };
            myLog('GET AUTH-KEY ::::::: INPUT', { ...config, headers: '<redacted>' });
            axios
                .create({
                    baseURL: INS_BASE_REST_URL,
                })(config)
                .then((response) => {
                    myLog('GET AUTH-KEY ::::::: response', response.data);
                    success(response.data);
                })
                .catch((err) => {
                    // Deliberately not routed through CatchErrorHandler: it turns
                    // a network/CORS failure into the app-wide "Server down"
                    // screen, and this is only one gate check.
                    myLog('GET AUTH-KEY ::::::: err', err);
                    failed(err);
                });
        });
    }

    static getV2(url, params, isAccessToken) {
        return new Promise(function (success, failed) {
            const config = {
                method: 'GET',
                url,
                params,
                headers: Client.httpHeader(isAccessToken, true),
                withCredentials: true,
            };
            myLog('GET ::::::: INPUT', config);
            axios
                .create({
                    baseURL: INS_BASE_REST_URL,
                })(config)
                .then((response) => {
                    try {
                        if (
                            response.status === Constants.HTTP_CODE.AUTHENTICATION_FAILURE ||
                            response.status === Constants.HTTP_CODE.REQUIRED_MISSING
                        ) {
                            throw new Error({
                                name: response.status,
                                message: Constants.VALIDATION_MSG.AUTH_FAILED,
                            });
                        }
                        if (response.status === Constants.HTTP_CODE.SUCCESS) {
                            try {
                                return response.data;
                            } catch (e) {
                                throw new Error({
                                    name: response.status,
                                    message: Constants.VALIDATION_MSG.REQ_FAILED,
                                });
                            }
                        }
                    } catch (e) {
                        throw new Error({
                            name: response.status,
                            message: Constants.VALIDATION_MSG.REQ_FAILED,
                        });
                    }
                })
                .then((response) => {
                    myLog('GET ::::::: resounse', response);
                    success(response);
                })
                .catch((err) => {
                    myLog('GET ::::::: err', err);
                    if (
                        err.response &&
                        err.response.status === Constants.HTTP_CODE.REQUIRED_MISSING
                    ) {
                        showSessionExpiredModal();
                    } else {
                        failed(CatchErrorHandler(err.message));
                    }
                });
        });
    }

    static getFileDownload(url, params, isAccessToken) {
        return new Promise(function (success, failed) {
            const config = {
                method: 'GET',
                url,
                params,
                responseType: 'blob',
                headers: Client.httpHeader(isAccessToken, false),
            };
            myLog('GET ::::::: INPUT', config);
            axios
                .create({
                    baseURL: INS_BASE_REST_URL,
                })(config)
                .then((response) => {
                    try {
                        if (
                            response.status === Constants.HTTP_CODE.AUTHENTICATION_FAILURE ||
                            response.status === Constants.HTTP_CODE.REQUIRED_MISSING
                        ) {
                            throw new Error({
                                name: response.status,
                                message: Constants.VALIDATION_MSG.AUTH_FAILED,
                            });
                        }
                        if (response.status === Constants.HTTP_CODE.SUCCESS) {
                            try {
                                return response.data;
                            } catch (e) {
                                throw new Error({
                                    name: response.status,
                                    message: Constants.VALIDATION_MSG.REQ_FAILED,
                                });
                            }
                        }
                    } catch (e) {
                        throw new Error({
                            name: response.status,
                            message: Constants.VALIDATION_MSG.REQ_FAILED,
                        });
                    }
                })
                .then((response) => {
                    myLog('GET ::::::: resounse', response);
                    success(response);
                })
                .catch((err) => {
                    myLog('GET ::::::: err', err);
                    if (
                        err.response &&
                        err.response.status === Constants.HTTP_CODE.REQUIRED_MISSING
                    ) {
                        showSessionExpiredModal();
                    } else {
                        failed(CatchErrorHandler(err.message));
                    }
                });
        });
    }

    static DELETE(url, params, isAccessToken) {
        return new Promise(function (success, failed) {
            const config = {
                method: 'DELETE',
                url,
                params,
                headers: Client.httpHeader(isAccessToken, false),
                withCredentials: true,
            };

            myLog('GET ::::::: INPUT', config);
            axios
                .create({
                    baseURL: INS_BASE_REST_URL,
                })(config)
                .then((response) => {
                    try {
                        if (
                            response.status === Constants.HTTP_CODE.AUTHENTICATION_FAILURE ||
                            response.status === Constants.HTTP_CODE.REQUIRED_MISSING
                        ) {
                            throw new Error({
                                name: response.status,
                                message: Constants.VALIDATION_MSG.AUTH_FAILED,
                            });
                        }
                        if (response.status === Constants.HTTP_CODE.SUCCESS) {
                            try {
                                return response.data;
                            } catch (e) {
                                throw new Error({
                                    name: response.status,
                                    message: Constants.VALIDATION_MSG.REQ_FAILED,
                                });
                            }
                        }
                    } catch (e) {
                        throw new Error({
                            name: response.status,
                            message: Constants.VALIDATION_MSG.REQ_FAILED,
                        });
                    }
                })
                .then((response) => {
                    myLog('GET ::::::: resounse', response);
                    success(response);
                })
                .catch((err) => {
                    myLog('GET ::::::: err', err);
                    if (
                        err.response &&
                        err.response.status === Constants.HTTP_CODE.REQUIRED_MISSING
                    ) {
                        showSessionExpiredModal();
                    } else {
                        failed(CatchErrorHandler(err.message));
                    }
                });
        });
    }

    static DELETENEW(url, data, isAccessToken) {
        return new Promise(function (success, failed) {
            const config = {
                method: 'DELETE',
                url,
                data,
                headers: Client.httpHeader(isAccessToken, false),
                withCredentials: true,
            };

            myLog('GET ::::::: INPUT', config);
            axios
                .create({
                    baseURL: INS_BASE_REST_URL,
                })(config)
                .then((response) => {
                    try {
                        if (
                            response.status === Constants.HTTP_CODE.AUTHENTICATION_FAILURE ||
                            response.status === Constants.HTTP_CODE.REQUIRED_MISSING
                        ) {
                            throw new Error({
                                name: response.status,
                                message: Constants.VALIDATION_MSG.AUTH_FAILED,
                            });
                        }
                        if (response.status === Constants.HTTP_CODE.SUCCESS) {
                            try {
                                return response.data;
                            } catch (e) {
                                throw new Error({
                                    name: response.status,
                                    message: Constants.VALIDATION_MSG.REQ_FAILED,
                                });
                            }
                        }
                    } catch (e) {
                        throw new Error({
                            name: response.status,
                            message: Constants.VALIDATION_MSG.REQ_FAILED,
                        });
                    }
                })
                .then((response) => {
                    myLog('GET ::::::: resounse', response);
                    success(response);
                })
                .catch((err) => {
                    myLog('GET ::::::: err', err);
                    if (
                        err.response &&
                        err.response.status === Constants.HTTP_CODE.REQUIRED_MISSING
                    ) {
                        showSessionExpiredModal();
                    } else {
                        failed(CatchErrorHandler(err.message));
                    }
                });
        });
    }

    static post(url, data, isAccessToken) {
        return new Promise(function (success, failed) {
            const config = {
                method: 'POST',
                url,
                data,
                headers: Client.httpHeader(isAccessToken, false),
                withCredentials: true,
            };
            myLog('POST ::::: Input', config);
            axios
                .create({
                    baseURL: INS_BASE_REST_URL,
                })(config)
                .then((response) => {
                    try {
                        if (
                            response.status === Constants.HTTP_CODE.AUTHENTICATION_FAILURE ||
                            response.status === Constants.HTTP_CODE.REQUIRED_MISSING
                        ) {
                            throw new Error({
                                name: response.status,
                                message: Constants.VALIDATION_MSG.AUTH_FAILED,
                            });
                        }
                        if (response.status === Constants.HTTP_CODE.SUCCESS) {
                            try {
                                return response.data;
                            } catch (e) {
                                throw new Error({
                                    name: response.status,
                                    message: Constants.VALIDATION_MSG.REQ_FAILED,
                                });
                            }
                        }
                    } catch (e) {
                        throw new Error({
                            name: response.status,
                            message: Constants.VALIDATION_MSG.REQ_FAILED,
                        });
                    }
                })
                .then((response) => {
                    myLog('POST ::::::: resounse', response);
                    success(response);
                })
                .catch((err) => {
                    myLog('POST ::::::: err', err);
                    if (
                        err.response &&
                        err.response.status === Constants.HTTP_CODE.REQUIRED_MISSING
                    ) {
                        showSessionExpiredModal();
                    } else {
                        failed(CatchErrorHandler(err.message));
                    }
                });
        });
    }

    static put(url, data, isAccessToken) {
        return new Promise(function (success, failed) {
            const config = {
                method: 'PUT',
                url,
                data,
                headers: Client.httpHeader(isAccessToken, false),
                withCredentials: true,
            };
            myLog('PUT ::::::: INPUT', config);
            axios
                .create({
                    baseURL: INS_BASE_REST_URL,
                })(config)
                .then((response) => {
                    myLog(response);
                    try {
                        if (
                            response.status === Constants.HTTP_CODE.AUTHENTICATION_FAILURE ||
                            response.status === Constants.HTTP_CODE.REQUIRED_MISSING
                        ) {
                            throw new Error({
                                name: response.status,
                                message: Constants.VALIDATION_MSG.AUTH_FAILED,
                            });
                        }
                        if (response.status === Constants.HTTP_CODE.SUCCESS) {
                            try {
                                return response.data;
                            } catch (e) {
                                throw new Error({
                                    name: response.status,
                                    message: Constants.VALIDATION_MSG.REQ_FAILED,
                                });
                            }
                        }
                    } catch (e) {
                        throw new Error({
                            name: response.status,
                            message: Constants.VALIDATION_MSG.REQ_FAILED,
                        });
                    }
                })
                .then((response) => {
                    myLog('PUT ::::::: resounse', response);
                    success(response);
                })
                .catch((err) => {
                    myLog('PUT ::::::: err', err);
                    if (
                        err.response &&
                        err.response.status === Constants.HTTP_CODE.REQUIRED_MISSING
                    ) {
                        showSessionExpiredModal();
                    } else {
                        failed(CatchErrorHandler(err.message));
                    }
                });
        });
    }

    // static disableOwnerOnVideoCall(visitId, userId) {
    //   return new Promise(function (success, failed) {
    //     const url = `${configUrl.INS_BASE_SOCKET_URL}${configUrl.DISABLE_OWNER_ON_VIDEO_CALL}/${visitId}/${userId}`;

    //     const config = {
    //       method: "GET",
    //       url,
    //       headers: Client.httpHeader(true, false),
    //     };

    //     myLog("DISABLE OWNER ON VIDEO CALL ::::::: INPUT", config);
    //     axios(config)
    //       .then((response) => {
    //         try {
    //           if (
    //             response.status === Constants.HTTP_CODE.AUTHENTICATION_FAILURE ||
    //             response.status === Constants.HTTP_CODE.REQUIRED_MISSING
    //           ) {
    //             throw new Error({
    //               name: response.status,
    //               message: Constants.VALIDATION_MSG.AUTH_FAILED,
    //             });
    //           }
    //           if (response.status === Constants.HTTP_CODE.SUCCESS) {
    //             try {
    //               return response.data;
    //             } catch (e) {
    //               throw new Error({
    //                 name: response.status,
    //                 message: Constants.VALIDATION_MSG.REQ_FAILED,
    //               });
    //             }
    //           }
    //         } catch (e) {
    //           throw new Error({
    //             name: response.status,
    //             message: Constants.VALIDATION_MSG.REQ_FAILED,
    //           });
    //         }
    //       })
    //       .then((response) => {
    //         myLog("DISABLE OWNER ON VIDEO CALL ::::::: response", response);
    //         success(response);
    //       })
    //       .catch((err) => {
    //         myLog("DISABLE OWNER ON VIDEO CALL ::::::: err", err);
    //         failed(CatchErrorHandler(err.message));
    //       });
    //   });
    // }
}

/**
 *
 * @param {*} error
 */
function CatchErrorHandler(error) {
    if (error.includes(Constants.VALIDATION_MSG.NO_INTERNET)) {
        return {
            status: Constants.NO_INTERNET,
            message: Constants.VALIDATION_MSG.NO_INTERNET,
        };
    }
    if (error.includes(Constants.HTTP_CODE.AUTHENTICATION_FAILURE)) {
        stores.dispatch(deactivateUserScreen(true));
        return;
    }
    if (error.includes(Constants.HTTP_CODE.INPUT_VALIDATION_ERROR)) {
        return {
            status: Constants.HTTP_CODE.INPUT_VALIDATION_ERROR,
            message: Constants.VALIDATION_MSG.AUTH_FAILED,
        };
    }
    if (error.includes(Constants.HTTP_CODE.REQUIRED_MISSING)) {
        return {
            status: Constants.HTTP_CODE.REQUIRED_MISSING,
            message: Constants.VALIDATION_MSG.AUTH_FAILED,
        };
    }
    if (error.includes(Constants.HTTP_CODE.REQUEST_TIMED_OUT_FAILURE)) {
        return {
            status: Constants.HTTP_CODE.REQUEST_TIMED_OUT_FAILURE,
            message: Constants.VALIDATION_MSG.REQ_FAILED,
        };
    }
    if (error.includes(Constants.HTTP_CODE.NO_DATA_FOUND)) {
        return {
            status: Constants.HTTP_CODE.NO_DATA_FOUND,
            message: Constants.VALIDATION_MSG.NO_DATA_FOUND,
        };
    }
    if (error.includes('Network Error')) {
        stores.dispatch(networkProblem(true));
        return {
            status: Constants.HTTP_CODE.REQUEST_TIMED_OUT_FAILURE,
            message: Constants.VALIDATION_MSG.REQ_FAILED,
        };
    }
    return {
        status: Constants.HTTP_CODE.REQUEST_TIMED_OUT_FAILURE,
        message: Constants.VALIDATION_MSG.REQ_FAILED,
    };
}

function get_domain() {
    const domain = window.location.hostname;
    const domainConfig = domainConfigurations.find((config) => config.domain === domain) || {};
    return domainConfig.bloomIfAI;
}

export function showSessionExpiredModal() {
    const existingModal = document.getElementById('session-expired-modal');
    if (existingModal) return;

    // Clear language preference keys on session expiry
    localStorage.removeItem('preferredLanguage');
    localStorage.removeItem('user_language');

    const sessionExpiredTitle = getTranslation('sessionExpiredTitle');
    const sessionExpiredMessage = getTranslation('sessionExpiredLoginMessage');
    const loginButtonLabel = getTranslation('goToLogin');

    const modal = document.createElement('div');
    modal.id = 'session-expired-modal';
    modal.innerHTML = `
    <div class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div class="bg-[#23262D] rounded-2xl shadow-xl p-6 max-w-sm w-full text-center">
                <h2 class="text-xl font-semibold mb-4 text-white">${sessionExpiredTitle}</h2>
                <p class="text-white mb-6">${sessionExpiredMessage}</p>
        <button id="modal-login-btn" class="bg-[#E24343] text-white px-4 py-2 rounded transition">
                    ${loginButtonLabel}
        </button>
      </div>
    </div>
  `;
    document.body.appendChild(modal);

    const loginButton = document.getElementById('modal-login-btn');
    const loginUrl = get_domain();
    loginButton.addEventListener('click', () => {
        window.location.href = loginUrl;
    });

    setTimeout(() => {
        window.location.href = loginUrl;
    }, 8000);
}
